import { memo } from "react";
import { useRecoilState } from "recoil";
import { Box, Stack } from "@mui/material";
import { settingsState } from "@/state/settings";
import ChatProfiles from "@/components/molecules/chatProfiles";
import NewChatButton from "@/components/molecules/newChatButton";
import { useLocation } from "react-router-dom";
import LanguageToggle from "../atoms/buttons/LanguageToggle";
import CompanyDropdown from "../molecules/CompanyDropdown";

type Props = {
  companyId?: string | number | undefined;
  setCompanyId?: (value: string) => void;
};

const Header = memo(({ companyId, setCompanyId }: Props) => {
  // const theme = useTheme();
  const [settings, setSettings] = useRecoilState(settingsState);
  const location = useLocation();
  const setSideBarOpen = (open: boolean) =>
    setSettings((prev) => ({ ...prev, isSideBarOpen: open }));

  return (
    <Box
      px={3}
      py={2}
      display="flex"
      height="60px"
      alignItems="center"
      flexDirection="row"
      justifyContent="space-between"
      color="text.primary"
      gap={2}
      id="header"
      position="relative"
      // sx={{
      //   backgroundColor: theme.palette.background.default,
      //   // borderBottom:
      //   //   theme.palette.mode === "dark" ? "none" : "1px solid #E4E5E5",
      // }}
    >
      <Box
        onClick={() => setSideBarOpen(!settings.isSideBarOpen)}
        sx={{ cursor: "pointer" }}
      >
        <img
          src="/view_sidebar_icon.svg"
          alt="Toggle Sidebar"
          style={{
            width: "30px",
            height: "30px",
            pointerEvents: "auto", // explicitly allow interaction
          }}
        />
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <ChatProfiles />
      </Box>

      <Box />
      {location.pathname === "/privacy-policies" && <LanguageToggle />}

      <Stack direction="row" alignItems="center" spacing={2}>
        <NewChatButton />

        {(location.pathname === "/" ||
          location.pathname.startsWith("/thread/")) && (
          <CompanyDropdown value={companyId} onChange={setCompanyId} />
        )}
      </Stack>
    </Box>
  );
});

export { Header };
